<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

 
body {
  min-height: 100vh;
}

#app {
  min-height: 100vh;
}
</style>
